function s(n) {
  var t, e, r = "";
  if (typeof n == "string" || typeof n == "number")
    r += n;
  else if (typeof n == "object")
    if (Array.isArray(n))
      for (t = 0; t < n.length; t++)
        n[t] && (e = s(n[t])) && (r && (r += " "), r += e);
    else
      for (t in n)
        n[t] && (r && (r += " "), r += t);
  return r;
}
function f() {
  for (var n = 0, t, e, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = s(t)) && (r && (r += " "), r += e);
  return r;
}
function a() {
  return a = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e)
        ({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, a.apply(null, arguments);
}
export {
  a as _,
  f as c
};
//# sourceMappingURL=extends-2c39a7b4.js.map
